/* Premium international tours — landing pages for tourist.com listings.
   TG: premium travellers from the US, Europe, Australia & UAE. Prices USD/EUR. */

import { CLASSIC_TOURS } from "./classicTours";

export const PREMIUM_TOURS = [
    {
        slug: "tiger-safari-india",
        name: "Tiger Safari",
        strap: "India's Big Cat, Four Legendary Forests",
        heroImage: "/api/assets/img/tiger-safari-premium.jpg",
        priceUsd: 1950,
        priceEur: 1800,
        duration: "12 days · 11 nights",
        bestTime: "October – April",
        regions: ["Ranthambore", "Jim Corbett", "Tadoba", "Sundarbans"],
        summary:
            "Track the royal Bengal tiger across four of India's greatest wildernesses — Ranthambore's fort-backed lakes, Corbett's sal forests, Tadoba's reliable tiger theatre and the mangrove labyrinth of the Sundarbans — with veteran naturalists, private 4x4 drives and premium eco-lodges that fund anti-poaching patrols.",
        highlights: [
            "10+ private dawn & dusk safari drives with expert naturalists",
            "Ranthambore: tigers against 10th-century fort ruins",
            "Tadoba: India's most consistent tiger sightings",
            "Sundarbans by boat — the world's only mangrove tiger habitat",
            "Premium eco-lodges; a share of every booking funds anti-poaching patrols",
        ],
        itinerary: [
            { d: "Days 1–2", t: "Delhi arrival & Ranthambore", x: "Private transfer, sundowner briefing, first dusk drive." },
            { d: "Days 3–5", t: "Ranthambore & Jim Corbett", x: "Dawn drives, fort walk, fly/drive north to Corbett's Ramganga valley." },
            { d: "Days 6–8", t: "Tadoba", x: "Central India's teak country — highest sighting probability of the trail." },
            { d: "Days 9–11", t: "Sundarbans", x: "Kolkata heritage evening, then two days by private boat in the delta." },
            { d: "Day 12", t: "Departure", x: "Fly out of Kolkata — or extend to Bandhavgarh / Kaziranga." },
        ],
        faqs: [
            { q: "Are tiger sightings guaranteed?", a: "No ethical operator guarantees wild animals — but across 10+ drives in four of India's best habitats, the overwhelming majority of our guests see multiple tigers." },
            { q: "When should I travel?", a: "October to April. March–April maximises sightings; November–February offers the most comfortable temperatures." },
        ],
    },
    {
        slug: "golden-triangle",
        name: "Golden Triangle",
        strap: "Delhi · Agra · Jaipur, Privately Curated",
        heroImage: "/api/assets/img/golden-triangle-premium.jpg",
        priceUsd: 1450,
        priceEur: 1350,
        duration: "7 days · 6 nights",
        bestTime: "October – March",
        regions: ["Delhi", "Agra", "Jaipur"],
        summary:
            "India's iconic first journey, elevated: sunrise at the Taj Mahal without the crowds, private historians in Mughal Delhi, dinner in a Jaipur palace, and stays in heritage hotels that were once royal residences. Fully private — your car, your guide, your pace.",
        highlights: [
            "Private sunrise access slot at the Taj Mahal with a specialist photographer-guide",
            "Old Delhi by cycle-rickshaw & food walk with a food historian",
            "Amber Fort private elephant-free ascent & block-printing atelier",
            "Heritage palace hotels throughout (Oberoi / Taj / RAAS category)",
            "Champagne dinner overlooking Jaipur's old city",
        ],
        itinerary: [
            { d: "Days 1–2", t: "Delhi", x: "Lutyens' Delhi, Humayun's Tomb, Old Delhi food walk." },
            { d: "Days 3–4", t: "Agra", x: "Taj at sunrise, Agra Fort, Mehtab Bagh at dusk, marble-inlay atelier." },
            { d: "Days 5–6", t: "Jaipur", x: "Amber Fort, City Palace private wing, bazaars with a stylist." },
            { d: "Day 7", t: "Departure", x: "Fly out of Jaipur — or extend to Ranthambore for tigers." },
        ],
        faqs: [
            { q: "Is this a group tour?", a: "No — fully private. Your own chauffeured car, dedicated guides in each city, and a 24/7 concierge on WhatsApp." },
            { q: "Can we add a tiger safari?", a: "Ranthambore is 3.5 hours from Jaipur — a two-night extension is our most popular add-on." },
        ],
    },
    {
        slug: "royal-rajasthan",
        name: "Royal Rajasthan",
        strap: "Palaces, Forts & Desert Citadels",
        heroImage: "/api/assets/img/royal-rajasthan-premium.jpg",
        priceUsd: 2950,
        priceEur: 2750,
        duration: "12 days · 11 nights",
        bestTime: "October – March",
        regions: ["Jaipur", "Jodhpur", "Udaipur", "Jaisalmer"],
        summary:
            "Live like the maharajas: two weeks through the land of kings — the blue city of Jodhpur, Udaipur's lake palaces, golden Jaisalmer rising from the Thar desert — staying in genuine palace hotels, dining with noble families, and ending under desert stars in a luxury camp.",
        highlights: [
            "Stay in real palaces: Taj Lake Palace category & heritage havelis",
            "Private dinner hosted by a Rajput noble family",
            "Mehrangarh Fort after-hours access with the fort's curator",
            "Thar desert luxury camp — camel-back sundowner & folk musicians",
            "Hot-air balloon over Amber Fort at dawn (seasonal)",
        ],
        itinerary: [
            { d: "Days 1–3", t: "Jaipur", x: "Pink city immersion, Amber at dawn, jewel ateliers." },
            { d: "Days 4–6", t: "Jodhpur", x: "Blue city walk, Mehrangarh private hours, stepwell picnic." },
            { d: "Days 7–8", t: "Jaisalmer & Thar", x: "Golden fort, luxury desert camp under the stars." },
            { d: "Days 9–11", t: "Udaipur", x: "Lake Pichola by private boat, City Palace, vintage car collection." },
            { d: "Day 12", t: "Departure", x: "Fly out of Udaipur." },
        ],
        faqs: [
            { q: "How much driving is involved?", a: "We fly the long legs and keep road transfers under 4 scenic hours, in a private chauffeured SUV." },
            { q: "Is it suitable for families?", a: "Beautifully — palace pools, camel rides, puppet shows and connecting suites are easily arranged." },
        ],
    },
    {
        slug: "hornbill-festival",
        name: "Hornbill Festival",
        strap: "Nagaland's Festival of Festivals",
        heroImage: "/api/assets/img/hornbill-premium.jpg",
        priceUsd: 2400,
        priceEur: 2250,
        duration: "8 days · 7 nights",
        bestTime: "1 – 10 December only",
        regions: ["Kohima", "Kisama", "Khonoma"],
        summary:
            "For ten days each December, seventeen Naga tribes gather at Kisama in full ceremonial regalia — feathered headdresses, log drums, fire dances and warrior games. This is Asia's most photogenic cultural gathering, and almost nobody from the West has seen it. Travel with our Naga-born cultural host.",
        highlights: [
            "Front-row access to Hornbill Festival ceremonies at Kisama",
            "Naga-born cultural host — invitations into tribal morungs (men's houses)",
            "Khonoma: India's first green village, terraced-valley walks",
            "Naga feast evenings — smoked pork, bamboo-steamed river fish, rice beer",
            "December's clear golden light — a photographer's dream",
        ],
        itinerary: [
            { d: "Days 1–2", t: "Dimapur → Kohima", x: "Arrival, WWII cemetery, first festival evening." },
            { d: "Days 3–5", t: "Hornbill Festival", x: "Full festival days at Kisama — ceremonies, games, night carnival." },
            { d: "Days 6–7", t: "Khonoma", x: "Green village homestay-boutique, forest & terrace walks." },
            { d: "Day 8", t: "Departure", x: "Fly out via Dimapur — or extend to Kaziranga's rhinos." },
        ],
        faqs: [
            { q: "Do I need a special permit?", a: "Foreign nationals register on arrival (we handle it); Indian nationals need an Inner Line Permit which we arrange in advance." },
            { q: "How limited is availability?", a: "Kohima has very few premium rooms and the festival is fixed to early December — we hold allocations, but booking by August is strongly advised." },
        ],
    },
    {
        slug: "palace-on-wheels",
        name: "Palace on Wheels",
        strap: "India's Legendary Royal Train",
        heroImage: "/api/assets/img/palace-on-wheels-premium.jpg",
        priceUsd: 4900,
        priceEur: 4550,
        duration: "8 days · 7 nights",
        bestTime: "September – April",
        regions: ["Jaipur", "Ranthambore", "Jaisalmer", "Udaipur", "Agra"],
        summary:
            "Board the train that redefined luxury rail: seven nights aboard the Palace on Wheels, waking each morning in a new princely state — tiger safaris from your carriage door, candle-lit forts, lake palaces and the Taj Mahal — with butler service, twin restaurants and a royal bar carriage.",
        highlights: [
            "7 nights aboard India's original luxury train — private cabin with butler",
            "Ranthambore tiger safari & Chittorgarh fort en route",
            "Jaisalmer camel procession & desert sundowner",
            "Udaipur lake lunch at a palace hotel",
            "Taj Mahal finale before returning to Delhi",
        ],
        itinerary: [
            { d: "Day 1", t: "New Delhi", x: "Champagne boarding ceremony, first night rolling south." },
            { d: "Days 2–4", t: "Jaipur · Ranthambore · Chittorgarh", x: "Pink city, tiger reserve drive, fort by lamplight." },
            { d: "Days 5–6", t: "Udaipur · Jaisalmer", x: "Lake Pichola, golden fort, dune sundowner." },
            { d: "Day 7", t: "Bharatpur · Agra", x: "Bird sanctuary at dawn, Taj Mahal at golden hour." },
            { d: "Day 8", t: "New Delhi", x: "Breakfast arrival — onward flights or extensions." },
        ],
        faqs: [
            { q: "What is included in the fare?", a: "Cabin with butler service, all meals aboard, all excursions with guides, park fees and station transfers. Alcohol and spa are à la carte." },
            { q: "When does it run?", a: "Weekly departures from Delhi, September to April. Peak dates (Dec–Feb) sell out months ahead — early reservation is essential." },
        ],
    },
    {
        slug: "wine-odyssey",
        name: "Epic Global Wine Odyssey",
        strap: "Eight Wine Regions, Four Continents",
        titleSuffix: "A Global Luxury Wine Tour",
        overline: "Premium Global Journeys · USD & EUR pricing",
        heroImage: "/api/assets/img/wine-odyssey-premium.jpg",
        priceUsd: 75000,
        priceEur: 69500,
        duration: "32 nights · 8 regions (customisable)",
        bestTime: "Year-round · region-sequenced",
        regions: ["Nashik", "Saint-Émilion", "Douro Valley", "Bordeaux & Champagne", "Tuscany & Langhe", "Scotland", "Australia", "South Africa"],
        summary:
            "A connoisseur's voyage across the world's greatest wine regions — from Nashik's boutique vineyards to Saint-Émilion's grand crus, the Douro's terraced quintas, Bordeaux and Champagne's legendary houses, Tuscany and Langhe's hilltop estates, Scotland's whisky coast, and the cellars of Australia and South Africa — with a personal sommelier, private estate access and luxury stays throughout.",
        highlights: [
            "Personal sommelier consultation & private cellar-door access in all 8 regions",
            "Four nights per destination — luxury châteaux, quintas & estate stays with breakfast",
            "Wine collection & shipping service, plus wine-investment insights",
            "Cultural immersion beyond the vine — markets, kitchens, harvest rituals",
            "Sustainable wine-tourism itinerary; fully customisable route & pace",
        ],
        itinerary: [
            { d: "Nights 1–4", t: "Nashik, India", x: "India's wine capital — boutique vineyard stays and tasting-room privates." },
            { d: "Nights 5–12", t: "Saint-Émilion · Bordeaux · Champagne", x: "Grand cru classé tastings, château stays, cellar lunches in France." },
            { d: "Nights 13–16", t: "Douro Valley, Portugal", x: "Terraced quintas, river cruises and vintage port verticals." },
            { d: "Nights 17–24", t: "Tuscany & Langhe · Scotland", x: "Brunello and Barolo estates, then Speyside's whisky-and-wine coast." },
            { d: "Nights 25–32", t: "Australia & South Africa", x: "Barossa and Margaret River, ending among Cape Winelands estates." },
        ],
        faqs: [
            { q: "What do the packages include?", a: "Standard ($75,000) is all-inclusive with luxury stays; Premium ($95,000) adds enhanced experiences and upgraded accommodation; Ultra-Luxury ($125,000) includes business-class travel between destinations. All include road transfers, private guided experiences and premium properties with breakfast. Airfare to the start point, visa and travel insurance are excluded." },
            { q: "Is there an age requirement?", a: "Yes — this tour is for guests aged 25 and above. Children may accompany parents for sightseeing, but wine tasting is not permitted. Note: consumption of alcohol is injurious to health." },
            { q: "Can we shorten the route?", a: "Absolutely — the 8-region, 32-night odyssey is fully customisable. Many guests choose a single-continent chapter of 8–12 nights." },
        ],
    },
    {
        slug: "andaman-islands",
        priceInr: 49999,
        name: "Enchanting Andaman",
        strap: "Azure Waters, White Sands, Island Seclusion",
        heroImage: "/api/assets/img/andaman-premium.jpg",
        priceUsd: 599,
        priceEur: 559,
        duration: "6 days · 5 nights",
        bestTime: "October – May",
        regions: ["Port Blair", "Havelock", "Neil Island"],
        summary:
            "The Andaman Islands are 'tropical paradise' made literal — palm-fringed beaches, miles of white sand and crystal turquoise water. Six days of island-hopping across Port Blair, Havelock and Neil Island with eco-friendly luxury stays, curated underwater experiences and offbeat corners the crowds never find — perfect for honeymooners and families alike.",
        highlights: [
            "Radhanagar Beach — repeatedly ranked among Asia's best",
            "Underwater wonders day: snorkel or scuba over living coral gardens",
            "Neil Island escapade — natural bridge, laid-back lagoon life",
            "Eco-friendly premium stays with modern amenities throughout",
            "Cellular Jail light-and-sound history evening in Port Blair",
        ],
        itinerary: [
            { d: "Day 1", t: "Welcome to Port Blair", x: "Arrival, island briefing, Cellular Jail sound-and-light evening." },
            { d: "Day 2", t: "Island Hopping", x: "North Bay & Ross Island — coral viewing and colonial ruins." },
            { d: "Day 3", t: "Havelock Island Paradise", x: "Ferry to Havelock, sunset at Radhanagar Beach." },
            { d: "Day 4", t: "Underwater Wonders", x: "Snorkelling or intro scuba at Elephant Beach's house reef." },
            { d: "Day 5", t: "Neil Island Escapade", x: "Natural bridge, Bharatpur beach, glass-bottom boat." },
            { d: "Day 6", t: "Port Blair & Departure", x: "Morning ferry back, souvenir stop, airport transfer." },
        ],
        faqs: [
            { q: "What do the packages cost?", a: "Per person on double occupancy: Standard ₹49,999 (~$599), Premium ₹59,999 and Luxury ₹74,999, plus taxes. Single supplement ₹15,000. International guests are quoted in USD/EUR at current rates." },
            { q: "How do we reach the Andamans?", a: "Direct flights to Port Blair from Delhi, Mumbai, Chennai, Bengaluru and Kolkata. We handle every transfer and ferry from touchdown to departure." },
            { q: "Is it good for honeymooners?", a: "It's one of our favourite honeymoon canvases — private beach dinners, couple dives and secluded stays are easily arranged. Families love it equally." },
        ],
    },
    {
        slug: "africa-safari",
        name: "Africa Safari — Kenya & Tanzania",
        strap: "The Great Migration, Eco-Luxury Style",
        titleSuffix: "Luxury Kenya & Tanzania Safari",
        overline: "Premium Global Journeys · USD & EUR pricing",
        heroImage: "/api/assets/img/africa-safari-premium.jpg",
        priceUsd: 2999,
        priceEur: 2780,
        duration: "8 – 15 days · 3 route options",
        bestTime: "July – October (Migration) · year-round game",
        regions: ["Masai Mara", "Serengeti", "Ngorongoro", "Tarangire", "Zanzibar"],
        summary:
            "Wildlife at its absolute best: three unforgettable East African routes — 7 nights of pure Masai Mara magic, the perfect Serengeti-and-Zanzibar combination, or the Ultimate 15-day Kenya & Tanzania adventure through the Mara, Serengeti, Ngorongoro Crater and Tarangire, ending on Zanzibar's idyllic beaches — in luxurious eco-accommodations with our happiness guarantee.",
        highlights: [
            "Front-row Great Migration game drives in the Mara & Serengeti",
            "Ngorongoro Crater — unparalleled biodiversity in one caldera",
            "Tarangire's baobab country and its great elephant herds",
            "Maasai cultural immersion & bush-dinner culinary evenings",
            "Luxurious eco-lodges and tented camps; family & honeymoon options",
        ],
        itinerary: [
            { d: "Days 1–4", t: "Masai Mara, Kenya", x: "Exclusive game drives in Kenya's premier wildlife reserve." },
            { d: "Days 5–7", t: "Serengeti, Tanzania", x: "The vast plains of the legendary Serengeti." },
            { d: "Days 8–9", t: "Ngorongoro Crater", x: "Descend into the crater's extraordinary natural amphitheatre." },
            { d: "Days 10–11", t: "Tarangire", x: "Baobab-dotted landscapes and large elephant herds." },
            { d: "Days 12–15", t: "Zanzibar", x: "Stone Town and tropical relaxation on idyllic beaches." },
        ],
        faqs: [
            { q: "Which of the three options should we pick?", a: "Magical Masai Mara (7 nights, Kenya only) for first-time safari-goers; Serengeti & Zanzibar for safari-plus-beach; the Ultimate Kenya & Tanzania (15 days) for the comprehensive East African experience. Our concierge will match one to your dates and budget." },
            { q: "When is the Great Migration?", a: "River crossings typically peak July–October in the Mara and Serengeti, but East Africa delivers world-class game viewing year-round — calving season (Jan–Mar) in the southern Serengeti is spectacular too." },
            { q: "Are these family- and honeymoon-friendly?", a: "Yes — family-friendly lodges with triple rooms and junior ranger activities, and honeymoon packages with private plunge-pool suites and bush dinners are all available." },
        ],
    },
];

export { CLASSIC_TOURS };

export const ALL_TOURS = [...PREMIUM_TOURS, ...CLASSIC_TOURS];

export const getTour = (slug) => ALL_TOURS.find((t) => t.slug === slug);
